if (!customElements.get('back-in-stock')) {
  customElements.define(
    'back-in-stock',
    class BackInStock extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        /**
         * @type {HTMLButtonElement | null}
         */
        this.submit = this.querySelector('button[type="submit"]');

        this.form?.addEventListener('submit', this.handleSubmit.bind(this));

        document.addEventListener('variantUpdated', this.handleVariantChange.bind(this));
      }

      /**
       * @param {SubmitEvent} event
       */
      handleSubmit(event) {
        event.preventDefault();

        if (!this.form?.action || !this.variantId) return;

        this.submit?.setAttribute('disabled', 'true');

        const formData = new FormData(this.form);
        formData.append('variant', this.variantId);

        const bodyData = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: `${this.form.email.value}` } } },
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.variantId}` } },
            },
          },
        };

        const options = {
          method: 'POST',
          headers: { revision: '2024-06-15', 'content-type': 'application/json' },
          body: JSON.stringify(bodyData),
        };

        fetch(this.form.action, options)
          .then((response) => {
            if (!response.ok) {
              return response.json();
            }
            return { errors: false };
          })
          .then((data) => {
            if (data.errors) {
              if (!this.messages.error) return;
              this.messages.error.textContent = data.errors[0].detail;

              this.messages.error?.removeAttribute('aria-hidden');
              this.submit?.removeAttribute('disabled');
            } else {
              this.form?.remove();
              this.messages.error?.remove();
              this.messages.success?.removeAttribute('aria-hidden');
            }
          })
          .catch((error) => {
            console.log('Error', error);
          });
      }

      /**
       * @param {CustomEvent} event
       */
      handleVariantChange(event) {
        if (!event.detail.variant) return;

        this.variantId = event.detail.variant.id;
      }

      get email() {
        /**
         * @type {HTMLInputElement | null}
         */
        const emailInput = this.form?.querySelector('input[name="email"]') || null;

        return emailInput?.value || false;
      }

      get productId() {
        return this.dataset.productId;
      }

      /**
       * @type {String | null}
       */
      get variantId() {
        return this._variantId || this.variantIdInput?.value || null;
      }

      set variantId(val) {
        this._variantId = val;
      }

      /**
       * @type {HTMLInputElement | null}
       */
      get variantIdInput() {
        return document.querySelector('[js-back-in-stock-variant-id]');
      }

      get messages() {
        return {
          success: this.querySelector('.back-in-stock__message--success'),
          error: this.querySelector('.back-in-stock__message--error'),
        };
      }
    },
  );
}
